import { t } from '@lingui/core/macro';
import BusinessIcon from '@mui/icons-material/Business';
import SyncIcon from '@mui/icons-material/Sync';
import { NoteIcon } from 'components/icons/NoteIcon';
import { OfferIconMUI } from 'components/icons/OfferIconMUI';
import { WarningIconMUI2 } from 'components/icons/WarningIconMUI2';
import { NavSection } from 'components/nav-section/NavSection';
import type { NavListProps } from 'components/nav-section/type';
import SvgIcon from 'components/SvgIcon';
import { app } from 'utils/appEnv';
import { truthy } from 'utils/arrayUtils';

export function FaksAdminNavSection() {
  const navItems: NavListProps[] = [
    {
      title: t`Accueil`,
      to: '/admin/home' as const,
      icon: <SvgIcon name="ic_home" />,
      hasDivider: true,
    },
    {
      title: t`Réclamations`,
      to: '/admin/invoices' as const,
      search: { tab: 'not_seen' },
      icon: <WarningIconMUI2 />,
    },
    {
      title: t`Périmés`,
      to: '/admin/expired_products_requests' as const,
      search: { tab: 'ongoing' },
      icon: <SvgIcon name="ic_expired" />,
    },
    {
      title: t`Opérations`,
      parentTo: '/admin/trades',
      icon: <OfferIconMUI />,
      children: [
        {
          title: t`Toutes`,
          to: '/admin/trades' as const,
        },
        {
          title: t`Labo`,
          to: '/admin/trades/master_trades' as const,
        },
        {
          title: t`Espace Pro`,
          to: '/admin/trades/konnect' as const,
        },
        {
          title: t`Validation Manuelle`,
          to: '/admin/trades/manual_validation' as const,
        },
        {
          title: t`Participations`,
          to: '/admin/trades/instances' as const,
        },
      ],
    },
    {
      title: t`Mails entrants`,
      to: '/admin/inbound-mails' as const,
      icon: <SvgIcon name="ic_mail" />,
    },
    {
      title: t`Notes de RDV`,
      to: '/admin/appointment-note-templates' as const,
      icon: <NoteIcon />,
    },
    {
      title: t`Factures fournisseurs`,
      parentTo: '/admin/kopilot' as const,
      icon: <SvgIcon name="ic_banking" />,
      children: [
        {
          title: t`Toutes`,
          to: '/admin/kopilot/invoices' as const,
          search: { tab: 'all' },
        },
        {
          title: t`Validées`,
          to: '/admin/kopilot/validated-invoices' as const,
          search: { status: 'all' },
        },
      ],
    },
    {
      title: t`Organisation`,
      icon: <BusinessIcon />,
      parentTo: ['/admin/labs', '/admin/groups', '/admin/pharmacies', '/admin/faks'],
      children: [
        {
          title: t`Laboratoires`,
          to: '/admin/labs' as const,
        },
        {
          title: t`Groupements`,
          to: '/admin/groups' as const,
        },
        {
          title: t`Pharmacies`,
          to: '/admin/pharmacies' as const,
        },
        {
          title: t`Faks`,
          to: '/admin/faks' as const,
        },
      ],
    },
    {
      title: t`Utilisateurs`,
      to: '/admin/users' as const,
      icon: <SvgIcon name="ic_user" />,
    },
    {
      title: t`Paiements`,
      to: '/admin/payments' as const,
      icon: <SvgIcon name="ic_euro" />,
      hasDivider: true,
    },
    {
      title: t`Konnect`,
      icon: <SyncIcon />,
      parentTo: '/onboarder',
      children: [
        {
          title: t`Identités à synchroniser`,
          to: '/onboarder/captchas' as const,
        },
      ],
    },
    {
      title: t`Outils`,
      icon: <SvgIcon name="ic_tools" />,
      parentTo: '/admin/tools',
      children: [
        {
          title: t`Impersonification`,
          to: '/admin/tools/impersonate' as const,
        },
        {
          title: t`Outil Marketing`,
          to: '/admin/tools/marketing_tools' as const,
        },
        {
          title: t`Hub d’ingestions`,
          to: '/admin/tools/ingestions' as const,
        },
        {
          title: t`Générateur Datamatrix`,
          to: '/admin/tools/datamatrix' as const,
        },
        {
          title: t`AI Prompt`,
          to: '/admin/tools/ai_prompt' as const,
        },
        app.env !== 'production' && {
          title: t`Générateur remontées panélistes`,
          to: '/admin/tools/sellout_panelist_generator' as const,
        },
        {
          title: t`Fusion de doublons`,
          to: '/admin/tools/pharmacies/merge' as const,
        },
        {
          title: t`Partenariats Groupements / Laboratoires`,
          to: '/admin/tools/groups_labs' as const,
        },
        {
          title: t`Pharmacies référentiel`,
          to: '/admin/tools/referential_pharmacies' as const,
        },
        {
          title: t`Tâches admin`,
          to: '/admin/admin_tasks' as const,
        },
      ].filter(truthy),
    },
  ];

  return <NavSection navItems={navItems} />;
}
